import { render, staticRenderFns } from "./closerefund.vue?vue&type=template&id=370ba5cb&scoped=true"
import script from "./closerefund.vue?vue&type=script&lang=js"
export * from "./closerefund.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "370ba5cb",
  null
  
)

export default component.exports